import React from 'react'
import { Navigate } from 'react-router'
import Navigation from '@App/navigation'
import RootScene from '@Scenes/RootScene'
import InactiveScene from '@Scenes/InactiveScene'
import AccessDeniedScene from '@Scenes/AccessDeniedScene'
import HelpScene from '@Scenes/HelpScene'
import ViewWorkPublicScene from '@Scenes/WorkScenes/ViewWorkPublicScene'
import PublicSearchScene from '@Scenes/PublicSearchScene'
import ForgotPasswordScene from '@Scenes/ForgotPasswordScene'
import CreatePasswordScene from '@Scenes/UserRegistrationScenes/CreatePasswordScene'
import UserRegistrationCompleteScene from '@Scenes/UserRegistrationScenes/UserRegistrationCompleteScene'
import UserRegistrationScene from '@Scenes/UserRegistrationScenes/UserRegistrationScene'
import UiComponentsScene from '@Scenes/UIComponentsScene'
import RequireAuth from '@Components/Utility/RequireAuth'
import ChangePasswordScene from '@Scenes/ProfileScene/ChangePasswordScene'
import ProfileScene from '@Scenes/ProfileScene'
import RecordingDetails from '@Scenes/RecordingDetailsScene'
import LoginScene from '@App/kit/scenes/LoginScene'
import EnrollMFAScene from '@Scenes/EnrollMFAScene'
import NotificationPreferencesScene from '@Scenes/NotificationPreferencesScene'
import Au10TixVerificationScene from '@Scenes/UserRegistrationScenes/Au10TixVerificationScene'
import {
    ACCESS_DENIED_ROUTE,
    CHANGE_PASSWORD_ROUTE,
    CONTACT_US_ROUTE,
    CREATE_PASSWORD_ROUTE_WITH_ACT_CODE,
    ENROLL_MFA_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    INACTIVE_ROUTE,
    KYC_ROUTE,
    LOGIN_ROUTE,
    NOTIFICATION_PREFERENCES_ROUTE,
    PROFILE_ROUTE,
    PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID,
    RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID,
    RELEASE_NOTES_ROUTE,
    SEARCH_ROUTE,
    SEARCH_ROUTE_WITH_TAB_NAME,
    SIGN_UP_COMPLETE_ROUTE,
    SIGN_UP_ROUTE,
    UI_ROUTE,
    UPCOMING_NOTES_ROUTE,
} from '@App/navigation/route'

export const createPublicRoutes = () => [
    { path: LOGIN_ROUTE, element: <LoginScene /> },
    { path: SIGN_UP_ROUTE, element: <UserRegistrationScene /> },
    { path: KYC_ROUTE, element: <Au10TixVerificationScene /> },
    { path: SIGN_UP_COMPLETE_ROUTE, element: <UserRegistrationCompleteScene /> },
    { path: CREATE_PASSWORD_ROUTE_WITH_ACT_CODE, element: <CreatePasswordScene /> },
    { path: ENROLL_MFA_ROUTE, element: <EnrollMFAScene /> },
    { path: FORGOT_PASSWORD_ROUTE, element: <ForgotPasswordScene /> },
    { path: SEARCH_ROUTE_WITH_TAB_NAME, element: <PublicSearchScene /> },
    { path: SEARCH_ROUTE, element: <PublicSearchScene /> },
    { path: PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID, element: <ViewWorkPublicScene /> },
    { path: CONTACT_US_ROUTE, element: <HelpScene /> },
    { path: ACCESS_DENIED_ROUTE, element: <AccessDeniedScene /> },
    { path: RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID, element: <RecordingDetails /> },
    { path: INACTIVE_ROUTE, element: <InactiveScene /> },
]

export const createAuthRoutes = () => [
    {
        path: RELEASE_NOTES_ROUTE,
        element: (
            <RequireAuth>
                <RootScene />
            </RequireAuth>
        ),
    },
    {
        path: UPCOMING_NOTES_ROUTE,
        element: (
            <RequireAuth>
                <RootScene />
            </RequireAuth>
        ),
    },
    {
        path: UI_ROUTE,
        element:
            window.APP_CONFIG.MLC_ENV !== 'production' ? (
                <RequireAuth>
                    <UiComponentsScene />
                </RequireAuth>
            ) : (
                <Navigate replace to={Navigation.home.root()} />
            ),
    },
    {
        path: PROFILE_ROUTE,
        element: (
            <RequireAuth>
                <ProfileScene />
            </RequireAuth>
        ),
    },
    {
        path: CHANGE_PASSWORD_ROUTE,
        element: (
            <RequireAuth>
                <ChangePasswordScene />
            </RequireAuth>
        ),
    },
    {
        path: NOTIFICATION_PREFERENCES_ROUTE,
        element: (
            <RequireAuth>
                <NotificationPreferencesScene />
            </RequireAuth>
        ),
    },
]
